// timeout 延时有关的函数

// delay时间后执行函数
export function timeout(delay = 0) {
    return new Promise(resolve => {
        delay = (isNaN(delay) === false && Number(delay) > 0) ? Number(delay) : 0;
        let timer = setTimeout(() => {
            clearTimeout(timer);
            resolve(delay);
            timer = null;
        }, delay);
    });
}

// 函数防抖，在delay时间内再次触发，只有最后一次操作能被触发
export function debounce(callback = null, delay = 10) {
    let timer = null;
    return function() {
        clearTimeout(timer);
        timer = setTimeout(() => callback.apply(this, arguments), delay);
    };
}

// 函数节流，在delay时间内只触发一次函数
export function throttle(callback = null, delay = 10) {
    let disable = false;
    return function() {
    	if (disable) {
    		return;
    	}
    	disable = true;
    	let timer = setTimeout(() => {
    		callback.apply(this, arguments);
            clearTimeout(timer);
    		disable = false;
            timer = null;
    	}, delay);
    };
}